(() => {
  if (window.gimmeHomeDetails) return;
  window.gimmeHomeDetails = true;

  const create = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };

  const productDetails = product => {
    const values = [product.bottleSize, product.abv].filter(Boolean);
    if (values.length === 2) {
      const abv = String(values[1]).includes('%') ? values[1] : `${values[1]}%`;
      return `${values[0]} / ${abv}`;
    }
    return values[0] || product.type || '';
  };

  function renderFinderResults(finder, collection, matches) {
    const results = finder.closest('.gimme-inspiration').querySelector('[data-finder-results]');
    const limit = Number(finder.dataset.resultsLimit) || 6;
    results.replaceChildren();
    results.hidden = false;

    if (!matches.length) {
      const empty = create('div', 'gimme-finder-empty');
      empty.append(create('p', '', 'No available matches found. Try another product type or budget.'));
      const browse = create('a', 'gimme-black-button', `Browse all ${collection.title}`);
      browse.href = collection.url;
      empty.append(browse);
      results.append(empty);
      return;
    }

    const heading = create('h3', 'gimme-finder-results-heading', finder.dataset.resultsHeading || 'Our Suggestions Are…');
    heading.tabIndex = -1;
    results.append(heading);
    results.append(create('p', 'visually-hidden', `${matches.length} available matches found. Showing ${Math.min(matches.length, limit)} suggestions.`));

    const list = create('ul', 'gimme-finder-product-grid');
    list.setAttribute('role', 'list');
    matches.slice(0, limit).forEach(product => {
      const item = create('li', 'gimme-finder-product-card');
      const link = create('a');
      link.href = product.url;
      const media = create('div', 'gimme-finder-product-media');

      if (product.saveText) media.append(create('span', 'gimme-round-badge', `Save\n${product.saveText}`));
      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = product.imageAlt || product.title;
        image.loading = 'lazy';
        image.width = 700;
        image.height = 700;
        media.append(image);
      } else {
        media.append(create('span', 'gimme-finder-image-placeholder', 'Image coming soon'));
      }

      link.append(media, create('h4', '', product.title));
      const details = productDetails(product);
      if (details) link.append(create('p', 'gimme-finder-product-details', details));
      link.append(create('p', 'gimme-finder-product-price', product.priceText));
      item.append(link);
      list.append(item);
    });
    results.append(list);

    const footer = create('div', 'gimme-finder-results-footer');
    const browse = create('a', 'gimme-black-button', `Browse all ${collection.title}`);
    browse.href = collection.url;
    footer.append(browse);
    results.append(footer);
    heading.focus({ preventScroll: true });
  }

  function init(root = document) {
    root.querySelectorAll('.gimme-handpicked').forEach(section => {
      if (section.dataset.bound) return;
      section.dataset.bound = 'true';
      const button = section.querySelector('[data-load-more]');
      if (!button) return;
      button.hidden = !section.querySelector('[data-extra][hidden]');
      button.addEventListener('click', () => {
        const next = [...section.querySelectorAll('[data-extra][hidden]')].slice(0, 6);
        next.forEach(card => { card.hidden = false; });
        section.querySelector('[data-load-status]').textContent = `${next.length} more products shown.`;
        if (!section.querySelector('[data-extra][hidden]')) {
          button.hidden = true;
          section.querySelector('.gimme-view-all').focus();
        }
      });
    });

    root.querySelectorAll('[data-finder]').forEach(finder => {
      if (finder.dataset.bound) return;
      finder.dataset.bound = 'true';
      const data = JSON.parse(finder.querySelector('[data-finder-data]').textContent);
      const drink = finder.querySelector('[data-drink]');
      const style = finder.querySelector('[data-style]');
      const budget = finder.querySelector('[data-budget]');
      const results = finder.closest('.gimme-inspiration').querySelector('[data-finder-results]');

      drink.addEventListener('change', () => {
        results.replaceChildren();
        results.hidden = true;
        style.replaceChildren(new Option('Any product type', ''));
        const collection = data[drink.value];
        style.disabled = !collection;
        if (collection) [...new Set(collection.products.map(product => product.type).filter(Boolean))].sort().forEach(type => style.add(new Option(type, type)));
      });

      finder.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const collection = data[drink.value];
        if (!collection) {
          results.hidden = false;
          results.textContent = 'Choose a drink to find matching products.';
          drink.focus();
          return;
        }
        const budgetLimit = Number(budget.value);
        const matches = collection.products.filter(product => product.available && (!style.value || product.type === style.value) && (!budgetLimit || product.price < budgetLimit));
        renderFinderResults(finder, collection, matches);
      });
    });
  }

  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
